import * as React from "react";
import {
  Select,
  Skeleton,
  Stack,
  Box,
  MenuItem,
  InputLabel,
  FormControl,
//   Autocomplete --> This can be used to make searchable component
} from "@mui/material";

const SelectMUI = ({
  label,
  id = "select-mui",
  value,
  options,
  onChange,
  isLoading,
}) => {
  const getLoader = () => {
    return (
      <>
        <MenuItem>
          <Stack
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
            spacing={0.5}
          >
            <Skeleton variant="circular" width={20} height={20} />
            <Skeleton variant="rounded" width={195} height={20} />
          </Stack>
        </MenuItem>
        <MenuItem>
          <Stack
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
            spacing={0.5}
          >
            <Skeleton variant="circular" width={20} height={20} />
            <Skeleton variant="rounded" width={195} height={20} />
          </Stack>
        </MenuItem>
        <MenuItem>
          <Stack
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
            spacing={0.5}
          >
            <Skeleton variant="circular" width={20} height={20} />
            <Skeleton variant="rounded" width={195} height={20} />
          </Stack>
        </MenuItem>
      </>
    );
  };

  return (
    <Box sx={{ minWidth: 120 }}>
      {label ? (
        <InputLabel id={`select-label-${id}`}>{label}</InputLabel>
      ) : null}
      <FormControl fullWidth>
        <Select
          id={`select-${id}`}
          value={value}
          onChange={isLoading ? () => null : onChange}
          MenuProps={{ PaperProps: { sx: { maxHeight: 250 } } }}
        >
          {isLoading
            ? getLoader()
            : options && options.length
            ? options.map((item, index) => {
                return (
                  <MenuItem key={`menu-item-${id}-${index}`} value={item.value}>
                    {item.label}
                  </MenuItem>
                );
              })
            : null}
        </Select>
      </FormControl>
    </Box>
  );
};

export default SelectMUI;
